import {
    WithdrawalAbilityDto,
    WithdrawalAbility,
    AccountData,
} from '@core/models/user/withdrawal/WithdrawalAbility';

import { transformWidthrawalFees } from '@core/mappers/user/transformWithdrawalFees';
import { getConfig } from '@superbet-group/web.lib.config';

export function getWithdrawalAbility(withdrawalAbility: WithdrawalAbilityDto): WithdrawalAbility {
    const hasFees = getConfig().countrySpecific.user.withdrawal.hasFees;
    const isOnlineEligible = withdrawalAbility.EligibleForOnlineWithdrawal;
    const isBankTransferEligible = withdrawalAbility.EligibleForBankTransferWithdrawal;
    const isShopEligible = withdrawalAbility.EligibleForCicoWithdrawal;
    const {
        [AccountData.AccountReference]: accountReference,
    } = withdrawalAbility.LastBankAccountUsed?.meta_data || {};

    return {
        isOnlineEligible,
        isBankTransferEligible,
        isShopEligible,
        willAnyBonusExpire: true,
        bonusesToExpire: withdrawalAbility.BonusesToExpire.map((e) => e.BonusIncetiveFriendlyName),
        withdrawalFees: hasFees ? transformWidthrawalFees(withdrawalAbility.WithdrawalFees) : null,
        ...(isBankTransferEligible && accountReference && {
            lastBankAccountUsed: {
                accountReference,
            },
        }),
    } as WithdrawalAbility;
}
